var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg65(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54577 14.782C6.89577 14.657 4.78744 12.4737 4.78744 9.79037C4.78744 7.03203 7.0291 4.79036 9.78744 4.79036C12.4708 4.79036 14.6541 6.8987 14.7791 9.5487L13.0291 9.0237C12.6874 7.5487 11.3624 6.45703 9.78744 6.45703C7.94577 6.45703 6.4541 7.9487 6.4541 9.79037C6.4541 11.3654 7.54577 12.6904 9.02077 13.032L9.54577 14.782ZM18.1208 9.79037C18.1208 10.0404 18.1124 10.2904 18.0874 10.5404L16.4458 10.0487C16.4541 9.96537 16.4541 9.8737 16.4541 9.79037C16.4541 6.10703 13.4708 3.1237 9.78744 3.1237C6.1041 3.1237 3.12077 6.10703 3.12077 9.79037C3.12077 13.4737 6.1041 16.457 9.78744 16.457C9.87077 16.457 9.96244 16.457 10.0458 16.4487L10.5374 18.0904C10.2874 18.1154 10.0374 18.1237 9.78744 18.1237C5.18744 18.1237 1.4541 14.3904 1.4541 9.79037C1.4541 5.19036 5.18744 1.45703 9.78744 1.45703C14.3874 1.45703 18.1208 5.19036 18.1208 9.79037ZM14.9791 13.3404L18.1208 12.2904L9.78744 9.79037L12.2874 18.1237L13.3374 14.982L16.8958 18.5404L18.5458 16.8904L14.9791 13.3404Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg65);
export default __webpack_public_path__ + "static/media/svg65.6c8d995e90e80e02581a213eb0412bb9.svg";
export { ForwardRef as ReactComponent };